<priva-form [formGroup]="productBoxFormGroup">
    <ng-container formArrayName="productBoxList">
        @for (productBox of productBoxList.controls; track productBox; let i = $index) {
            <div [formGroupName]="i" class="form-group-wrapper">
                <priva-form-group [hasLabel]="false" [hasHelp]="false" [isInline]="true">
                    <span class="product-box-amount-label">{{ 'GENERAL.TITLE.BOX' | translate }}</span>
                    @if ((hasDefaultProductBox$ | async) === true) {
                        <input
                            class="product-box-amount-text-input"
                            priva-input
                            type="text"
                            formControlName="productBoxName"
                            alignment="Left"
                            [attr.data-test]="
                                productBoxList.controls.length > 1
                                    ? 'product-box-text-input-' + i
                                    : 'product-box-text-input'
                            "
                            name="product-box-text-input"
                            readonly
                            tabindex="-1"
                        />
                    } @else {
                        <select
                            class="product-box-select"
                            priva-select
                            *ngrxLet="productBoxes$ | async as productBoxes"
                            [options]="productBoxes?.privaSelectOption || []"
                            formControlName="productBoxNumber"
                            placeholder="Select product box"
                            data-test="product-box-select"
                        ></select>
                    }
                    <span class="product-box-amount-label fas fa-times"></span>
                    <div class="amount-input-wrapper" #amountResultInput>
                        <input
                            #amountInput
                            priva-input
                            placeholder=""
                            formControlName="amount"
                            type="text"
                            inputmode="decimal"
                            (keydown.enter)="blurInput(i)"
                            [attr.data-test]="
                                productBoxList.controls.length > 1
                                    ? 'input-amount-result-' + i
                                    : 'input-amount-result'
                            "
                            [readonly]="(hasDefaultProductBoxDefined$ | async) === false"
                        />
                    </div>
                    @if (productBoxFormGroup.controls['productBoxList'].controls[i].invalid) {
                        <priva-popover
                            [relativeTo]="amountResultInput"
                            placement="top"
                            theme="onwhite"
                            status="Danger"
                            [autoClose]="false"
                            density="lg"
                            data-test="amount-result-error"
                        >
                            {{
                                productBoxFormGroup.controls['productBoxList'].controls[i].errors?.['format']
                                    | translate
                                        : {
                                              formatErrorValue:
                                                  productBoxFormGroup.controls['productBoxList'].controls[i]
                                                      .errors?.['errorValue'],
                                          }
                            }}
                        </priva-popover>
                    }
                </priva-form-group>
            </div>
        }
    </ng-container>
</priva-form>
